import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon
} from 'reactstrap';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2';
import moment from 'moment';

import IconSave from 'react-icons/lib/md/save';

import * as actions from '../../actions/cotizacion';

import Select from 'react-select';

import {api, API_URL} from '../../actions/_request';

import ReactTable from "react-table";
import "react-table/react-table.css";
const SubmitLoad = () => (
	<div className="p-2">
		<Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
	</div>
);
const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String((row[id]+'').toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };




class TicketModal extends React.Component
{
	constructor(props)
	{
		super(props)

		this.state = {
            correo:'',
            cc:[],
            cc_text:'',
            factura:[],
            fecha_inicio : moment().add(0, 'days').format('Y-MM-DD'),
            fecha_fin    : moment().add(1, 'days').format('Y-MM-DD'),
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

      
	}

   
    handleInputChange(event) {
        let {impuesto} = this.state;
        const target    = event.target;
        let value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

        this.setState({
           [name] : value,
        });
    }

	handleSubmit(evt)
	{    
        evt.preventDefault();
        let {fecha_inicio , fecha_fin } = this.state;
        window.open(`${API_URL}/seguimiento_cotizaciones/${fecha_inicio}/${fecha_fin}`)
	}

	render()
	{
            let {fecha_inicio , fecha_fin } = this.state;
		return(

			<Modal isOpen={this.props.open} toggle={this.props.toggle} style={{marginTop: '0'}} className="default modal-lg">
				<form onSubmit={this.handleSubmit}>
                <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                    <div className="row">
                    <div className="col-4">
                            <div className="form-group">
                                <label>inicio:</label>
                                <Input
                                    placeholder=""
                                    type="date"
                                    name="fecha_inicio"
                                    value={fecha_inicio}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="form-group">
                                <label>Fin:</label>
                                <Input
                                    placeholder=""
                                    type="date"
                                    name="fecha_fin"
                                    value={fecha_fin}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                        </div>
                    </div>                 
                </ModalBody>
                <ModalFooter>
                    {
                    	this.props.cotizacion.saving ?
                    	<SubmitLoad /> : 
                    	<div>
                    		<Button color="primary" type="submit" >
                    			Enviar
                    		</Button>{' '}
                    		<Button color="secondary" onClick={this.props.toggle}>
		                    	Cancel
		                    </Button>
                    	</div>
                    }
                </ModalFooter>
                </form>
            </Modal>
		);
	}
}

function mapStateToProps(state, ownProps) {
    return {
        cotizacion : state.cotizacion,
    }
};

export default connect(mapStateToProps, actions)(TicketModal)


// WEBPACK FOOTER //
// ./src/components/cotizaciones/ModalReportes.js